export default __webpack_public_path__ + "static/media/homepage-support.86413684.jpg";